import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import ErrorResponse from './ErrorResponse';
import { Group, mapGroup } from './Group';

export interface Result {
	readonly czReimbursement: Group;
}

export const findGroup = async (client: ApiClient, userId: string, groupId: string): Promise<Result> => {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/cz-reimbursement-group');
	try {
		const response = await client.fetch(url.expand({ userId, groupId }));
		const body = await response.json();
		return { czReimbursement: mapGroup(body.czReimbursement) };
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
};
